"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogBrowserSelectorItem = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
// Styles from Vizportal "Spaces Explorer"
var ItemContainer = data_catalog_shared_1.divWithStyle('ItemContainer', __assign(__assign({}, data_catalog_shared_1.flexRowStyle), { justifyContent: 'space-between', whiteSpace: 'nowrap', padding: '6px 0', fontFamily: data_catalog_shared_1.vizPortalFontStyle.fontFamily }));
var CountLabel = data_catalog_shared_1.divWithStyle('CountLabel', {
    minWidth: 36,
    marginLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    textAlign: 'right',
    color: widgets_1.TabStyles.Typography.Color.Disabled
});
function CatalogBrowserSelectorItem(props) {
    /* Story 1199789: [Spike] Decide how to handle result sets larger than 10K
     * Until the spike and resulting stories are completed to support access more than 10k assets, we need to render 10,000+
     * for those in the following conditions:
     *   External Assets feature is enabled
     *   Count is equal or greater than 10k
     *
     * There is a work item to remove these changes once that is in.
     * Story 1247162: [External Assets & Connect-To] Remove client workaround (display "10000+") once CRASS returns the actual total count
    */
    var showTenThousandPlus = false;
    if (props.count != null && props.featureFlags) {
        showTenThousandPlus = props.featureFlags.externalAssetsWithCRASSEnabled && props.count >= 10000;
    }
    var tenThousandPlus = Localize_1.Formatters.formatCount(10000) + '+';
    return (React.createElement(ItemContainer, null,
        React.createElement("div", null, props.subplaceName),
        React.createElement(CountLabel, null, showTenThousandPlus ? tenThousandPlus : props.count)));
}
exports.CatalogBrowserSelectorItem = CatalogBrowserSelectorItem;
//# sourceMappingURL=CatalogBrowserSelectorItem.js.map